import { getAllEnumValues } from '@upright/common/utils';
import { z } from 'zod';
import { ResolverQualityLevel } from '../../../../internal/product-resolver/types';
import { CommonCompanyMetadata } from '../types';

// modify it, create a new type instead.
// TODO: Change to human-readable form and migrate db occurences
export enum RevenueShareClass {
  MAJOR = 2,
  MEDIUM = 1,
  MINOR = 0,
  UNKNOWN = 3,
}
export const zRevenueShareClass = z.nativeEnum(RevenueShareClass);
export const allRevenueShareClasses = getAllEnumValues(RevenueShareClass, 'number');

export const zCompanyProductSetProduct = z.object({
  version: z.literal(1),
  productCode: z.string(),
  revenueShareClass: zRevenueShareClass.optional(),
  revenueShare: z.number().optional(),
});
export type CompanyProductSetProduct = z.infer<typeof zCompanyProductSetProduct>;

export interface CompanyProductSet extends CommonCompanyMetadata {
  id: number;
  isInactive: boolean;
  isPrimary: boolean;
  blanketProductSetId?: number;
  products: CompanyProductSetProduct[];
  source: string;
  quality?: ResolverQualityLevel;
  startDate: string | undefined;
  endDate: string | undefined;
  disclosedRevenueYear: number | undefined;
  createdBy: string;
  readableBy: number;
  /**
   * IPRA snapshot copied from the linked blanket set at publish (PLT-5539). Read
   * this instead of re-deriving IPRA-ness from the blanket set's source.
   */
  isIpra: boolean;
}

// TODO OA: Remove once UI can edit product set dates
// Also at this time, fix createProductSet to force dates to start of day
export const TEMP_PRODUCT_SET_DEFAULT_DATE = '2020-01-01T00:00:00.111Z';

/**
 * Ratios for company products
 */
export interface ProductRatios {
  [productCode: string]: number;
}
